// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentWithEmailSignatureTemplateRequest {
    static getAttributeTypeMap() {
        return EnrollmentWithEmailSignatureTemplateRequest.attributeTypeMap;
    }
}
EnrollmentWithEmailSignatureTemplateRequest.discriminator = undefined;
EnrollmentWithEmailSignatureTemplateRequest.additionalProperties = false;
EnrollmentWithEmailSignatureTemplateRequest.attributeTypeMap = [
    {
        "name": "enrollmentRequest",
        "baseName": "enrollmentRequest",
        "type": "EnrollPatientRequestModel"
    },
    {
        "name": "emailSignatureTemplateRequest",
        "baseName": "emailSignatureTemplateRequest",
        "type": "EmailSignatureTemplateRequest"
    },
];
//# sourceMappingURL=enrollmentWithEmailSignatureTemplateRequest.js.map